import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMenuItems } from '../../services/api';

export const fetchMenu = createAsyncThunk('menu/fetchMenu', async () => {
  const data = await getMenuItems();
  return data;
});

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    items: [],
    loading: false,
    error: null as string | null,
  },
  reducers: {
    clearMenu: (state) => {
      state.items = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenu.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenu.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchMenu.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Menu fetch failed';
      });
  },
});

export const { clearMenu } = menuSlice.actions;
export default menuSlice.reducer;